<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
        <div class="form-group row">
            <div class="col-md-8">
                <yt-input [Type]="'text'" name="txtNaziv" formControlName="Naziv" [MaxLength]="50"
                    [ngClass]="{ 'is-invalid': submitted && fc.Naziv.invalid }"
                    [Label]="'EOTPREMNICASTAVKADODATNIATRIBUT.NAZIV.SINGULAR'"
                    #autofocus>
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                    <span *ngFor="let validation of errorMessages.Naziv">
                        <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span
                                translate="{{ validation.message }}"></span></span>
                    </span>
                </div>
            </div>
            <div class="col-md-4">
                <yt-input [Type]="'text'" name="txtVrednost" formControlName="Vrednost" [MaxLength]="30"
                    [ngClass]="{ 'is-invalid': submitted && fc.Vrednost.invalid }"
                    [Label]="'EOTPREMNICASTAVKADODATNIATRIBUT.VREDNOST.SINGULAR'">
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Vrednost.invalid">
                    <span *ngFor="let validation of errorMessages.Vrednost">
                        <span class="error-message" *ngIf="fc.vrednost.hasError(validation.type)"><span
                                translate="{{ validation.message }}"></span></span>
                    </span>
                </div>
            </div>

        </div>
    </form>
</div>